import * as React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import { LightboxOverlay, OverlayCloseButton } from '../../overlay'
import { Container } from '../../grid'
import PostalCodeSelector from './PostalCodeSelector'

const OverlayContent = styled(Container)`
  position: relative;
  padding: 25px 40px 40px;
  background-color: ${theme('postalCodeOverlay.backgroundColor')};
  max-width: 600px;
  margin: 0;
  min-height: 250px;
  border-radius: ${theme('postalCodeOverlay.borderRadius')};
`

const StyledCloseButton = styled(OverlayCloseButton)`
  position: absolute;
  top: 20px;
  color: #333;
  right: 20px;
  margin-bottom: 0;
  margin-right: 0;
`

class PostalCode extends React.Component {
  constructor(props) {
    super(props)
    this.onCancel = this.onCancel.bind(this)
  }

  onCancel() {
    this.props.setClosed()
  }

  render() {
    return (
      <LightboxOverlay setClosed={this.onCancel}>
        <OverlayContent>
          <PostalCodeSelector
            headline={this.props.headline}
            label={this.props.label}
            onChange={this.props.onChange}
            placeholder={this.props.placeholder}
            buttonText={this.props.buttonText}
            error={this.props.error}
          />
          <StyledCloseButton
            inverted
            onClick={this.onCancel}
            title={this.props.cancelText}
          />
        </OverlayContent>
      </LightboxOverlay>
    )
  }
}

PostalCode.propTypes = {
  onChange: PropTypes.func.isRequired,
  setClosed: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.string,
  buttonText: PropTypes.string,
  cancelText: PropTypes.string,
  placeholder: PropTypes.string,
  headline: PropTypes.string,
}

PostalCode.defaultProps = {
  label: null,
  error: null,
  buttonText: null,
  cancelText: null,
  headline: null,
  placeholder: null,
  setClosed: () => {},
}

export default PostalCode
